import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid, Paper } from '@mui/material';

import ServiceConfigCard from './ServiceConfigCard';
import { SERVICE_CONFIG_KEYS } from '../../constants';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';

const { CONFIGS, ENABLED, SERVICE_TYPE } = SERVICE_CONFIG_KEYS;

const ServiceConfig = () => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);
	const commonStyleClasses = useCommonStyles();
	const serviceConfigs =
		(bannerFpConfig && Array.isArray(bannerFpConfig[CONFIGS]) && bannerFpConfig[CONFIGS]) || [];

	const addServiceConfig = () => {
		const initialServiceConfig = { [ENABLED]: false, [SERVICE_TYPE]: '' };
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		if (!clonedBannerFpConfig[CONFIGS]) {
			clonedBannerFpConfig[CONFIGS] = [];
		}
		clonedBannerFpConfig[CONFIGS].push(initialServiceConfig);
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	const deleteServiceConfig = (index) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const serviceConfigs = clonedBannerFpConfig[CONFIGS];

		const newServiceConfigs = serviceConfigs.filter((data, idx) => idx !== index);
		clonedBannerFpConfig[CONFIGS] = newServiceConfigs;

		updateBannerFpConfig(clonedBannerFpConfig);
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Service Config"
				headingPath={['Dashboard', 'Banner Fp', 'Service Config']}
			/>
			<Grid container spacing={2} style={{ margin: '5rem auto 0 auto', width: '94%' }}>
				{serviceConfigs && (
					<>
						{serviceConfigs.map((serviceConfig, index) => {
							return (
								<ServiceConfigCard
									serviceConfig={serviceConfig}
									deleteServiceConfig={deleteServiceConfig}
									key={index}
									index={index}
								/>
							);
						})}
						<Grid item xs={12} style={{ textAlign: 'center' }}>
							<AddCircleOutlineOutlinedIcon
								color="primary"
								fontSize="medium"
								className={commonStyleClasses.icon}
								onClick={addServiceConfig}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};

export default ServiceConfig;
